import { Component } from '@angular/core';
export class CodeLikeProComponent {
constructor() {
       
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-root',
  template: `
    <welcome></welcome>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CodeLikeProComponent_tsickle_Closure_declarations() {
/** @type {?} */
CodeLikeProComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CodeLikeProComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
